document.addEventListener("DOMContentLoaded", () => {
    const activeClass = "custVideoActive";
    const toggleClasses = (wrapper, shouldAdd) => {
        if (shouldAdd) {
            wrapper.classList.add(activeClass);
            document.body.classList.add(activeClass);
        } else {
            wrapper.classList.remove(activeClass);
            document.body.classList.remove(activeClass);
        }
    };
    const initYouTubeAPI = () => {
        if (!window.YT) {
            if (!document.querySelector('script[src*="iframe_api"]')) {
                const tag = document.createElement("script");
                tag.src = "https://www.youtube.com/iframe_api";
                document.body.appendChild(tag);
            }
            window.onYouTubeIframeAPIReady = () => {
                window.dispatchEvent(new Event("yt-api-ready"));
            };
        }
    };
    const setupMedia = (el, wrapper) => {
        if (el.dataset.videoInit) return;
        el.dataset.videoInit = "true";
        if (el.tagName === "VIDEO") {
            el.addEventListener("play", () => toggleClasses(wrapper, true));
            el.addEventListener("pause", () => toggleClasses(wrapper, false));
            el.addEventListener("ended", () => toggleClasses(wrapper, false));
        }
        else if (el.src.includes("youtube.com")) {
            if (!el.src.includes("enablejsapi=1")) {
                const sep = el.src.includes("?") ? "&" : "?";
                el.src += sep + "enablejsapi=1";
            }
            const createYTPlayer = () => {
                new YT.Player(el, {
                    events: {
                        onStateChange: (event) => {
                            if (event.data === YT.PlayerState.PLAYING) toggleClasses(wrapper, true);
                            else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) toggleClasses(wrapper, false);
                        }
                    }
                });
            };
            if (window.YT && window.YT.Player) createYTPlayer();
            else window.addEventListener("yt-api-ready", createYTPlayer);
        }
        else if (el.src.includes("vimeo.com")) {
            const initVimeo = () => {
                const player = new Vimeo.Player(el);
                player.on("play", () => toggleClasses(wrapper, true));
                player.on("pause", () => toggleClasses(wrapper, false));
                player.on("ended", () => toggleClasses(wrapper, false));
            };
            if (window.Vimeo) initVimeo();
            else {
                if (!document.querySelector('script[src*="player.js"]')) {
                    const tag = document.createElement("script");
                    tag.src = "https://player.vimeo.com/api/player.js";
                    tag.onload = initVimeo;
                    document.body.appendChild(tag);
                } else {
                    const checkVimeo = setInterval(() => {
                        if (window.Vimeo) { clearInterval(checkVimeo); initVimeo(); }
                    }, 100);
                }
            }
        }
    };
    const scanAllVideos = () => {
        document.querySelectorAll(".custHideTextWhnPlaVdo").forEach((wrapper) => {
            const mediaElements = wrapper.querySelectorAll("video, iframe");
            mediaElements.forEach((media) => setupMedia(media, wrapper));
        });
    };
    initYouTubeAPI();
    scanAllVideos();
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) scanAllVideos();
        });
    });
    document.querySelectorAll(".custHideTextWhnPlaVdo").forEach((wrapper) => {
        observer.observe(wrapper, { childList: true, subtree: true });
    });
});
document.addEventListener("DOMContentLoaded", () => {
  const nonstopWrappers = document.querySelectorAll(".custNonstopPlayVideo .deferred-media");
  nonstopWrappers.forEach(wrapper => {
    const template = wrapper.querySelector("template");
    if (!template) return;
    const content = template.content.cloneNode(true);
    const video = content.querySelector("video");
    if (!video) return;
    video.removeAttribute("controls");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.loop = true;
    video.muted = true;
    video.autoplay = true;
    wrapper.innerHTML = "";
    wrapper.appendChild(video)
    const tryPlay = () => {
      video.play().catch(() => {
        setTimeout(() => video.play().catch(() => {}), 800);
      });
    };
    tryPlay();
    video.addEventListener("pause", tryPlay);
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const fixDuplicateVideos = () => {
    const containers = document.querySelectorAll(".custSwtchLpVdo");
    containers.forEach((container) => {
      const mediaElements = container.querySelectorAll(".deferred-media");
      if (mediaElements.length > 1) {
        for (let i = 1; i < mediaElements.length; i++) {
          mediaElements[i].remove();
        }
      }
      const wrapper = container.querySelector(".deferred-media");
      if (!wrapper || wrapper.dataset.videoProcessed === "true") return;

      const template = wrapper.querySelector("template");
      if (!template) return;

      const content = template.content.cloneNode(true);
      const video = content.querySelector("video");

      if (!video) return;

      video.removeAttribute("controls");
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("autoplay", "");
      video.loop = true;
      video.muted = true;
      video.autoplay = true;

      wrapper.dataset.videoProcessed = "true";
      wrapper.innerHTML = ""; 
      wrapper.appendChild(video);

      const tryPlay = () => {
        if (document.body.contains(video)) {
          video.play().catch(() => {
            setTimeout(() => video.play().catch(() => {}), 800);
          });
        }
      };

      tryPlay();
      video.addEventListener("pause", tryPlay);
    });
  };
  fixDuplicateVideos();
  document.addEventListener("shopify:section:load", fixDuplicateVideos);
});
document.addEventListener("DOMContentLoaded", () => {
  const cleanEmptyParagraphs = () => {
    const paragraphs = document.querySelectorAll(
      ".custRemoveEmptyP.image-with-text-logos .content-part .content-partCld .logo-row.custnewIconTxtt .icon-text-block p"
    );
    paragraphs.forEach((p) => {
      if (p.innerText.trim() === "") {
        p.remove();
      }
    });
  };
  cleanEmptyParagraphs();
  document.addEventListener("shopify:section:load", cleanEmptyParagraphs);
});


jQuery(window).on('load', function() {
    const videoHtml = `
        <video playsinline="playsinline" autoplay="autoplay" preload="metadata" loop muted poster="//www.dexon.com.au/cdn/shop/files/preview_images/a22c6e7975914ac7ae800aee4320b323.thumbnail.0000000000_1100x.jpg?v=1779942139">
            <source src="https://cdn.shopify.com/videos/c/o/v/32b84484537947bb91c8c7f51ab2af22.mp4" type="video/mp4">
            <img src="//www.dexon.com.au/cdn/shop/files/preview_images/a22c6e7975914ac7ae800aee4320b323.thumbnail.0000000000_1100x.jpg?v=1779942139">
        </video>
    `;
    jQuery('.custrangerswitchsec2 .video-section__media')
        .attr('loaded', 'true')
        .append(videoHtml);
});